export default __webpack_public_path__ + "static/media/Karnataka6.fbd285f7.png";